import React from 'react';
import { motion } from 'framer-motion';
export function MissionSection() {
  return <section className="py-20 md:py-28 bg-gray-50" aria-labelledby="mission-heading" id="about" data-id="element-221">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-222">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-223">
          {/* Left: Image */}
          <motion.div className="w-full lg:w-1/2" initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} data-id="element-224">
            <div className="relative w-full min-h-[400px] rounded-[10px] overflow-hidden" data-id="element-225">
              <img src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800&q=80" alt="Healthy Choice Family Clinic team providing patient care" className="w-full h-full object-cover absolute inset-0" data-id="element-226" />
            </div>
          </motion.div>

          {/* Right: Text Content */}
          <motion.div className="w-full lg:w-1/2 space-y-8" initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7,
          ease: 'easeOut',
          delay: 0.2
        }} data-id="element-227">
            <div data-id="element-228">
              <p className="text-sm font-bold tracking-[0.2em] uppercase text-teal-500 mb-4" data-id="element-229">
                About Our Practice
              </p>
              <h2 id="mission-heading" className="text-2xl md:text-3xl lg:text-4xl font-bold text-navy-500 leading-snug mb-6" data-id="element-230">
                Providing Accessible, High-Quality Healthcare to Our Community
              </h2>
              <p className="text-lg text-gray-500 leading-relaxed mb-4" data-id="element-231">
                Healthy Choice Family Clinic & Urgent Care is a full-service
                medical practice serving Landover and Oxon Hill, Maryland. We
                provide comprehensive primary care, urgent care, and specialty
                services for patients of all ages.
              </p>
              <p className="text-lg text-gray-500 leading-relaxed" data-id="element-232">
                As a Patient-Centered Medical Home (PCMH), our patients receive
                preventative services and screenings at a higher rate. We accept
                most major insurance plans and offer a sliding fee scale —
                because no one should be turned away from quality healthcare.
              </p>
            </div>

            <div className="border-l-4 border-teal-500 pl-6 py-2" data-id="element-233">
              <p className="font-script text-xl md:text-2xl italic text-navy-500/80 leading-relaxed mb-4" data-id="element-234">
                "We believe that every patient deserves to be treated with
                dignity, compassion, and the highest standard of care —
                regardless of their ability to pay."
              </p>
              <p className="font-semibold text-navy-500" data-id="element-235">
                — Healthy Choice Family Clinic Leadership
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}